import React, { useState } from "react";
import "./App.css";
import NavBar from "./Components/NavBar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../src/Assets/Styles/animate.css";
import HomePage from "./Pages/HomePage/HomePage";
import About from "./Pages/About/About";
import Footer from "./Components/Footer";
import TermsCondition from "./Components/TermsCondition";
import Hospitals from "./Pages/Hospitals/Hospitals";
import AfCare from "./Pages/AFCare/AfCare";
import { FAQSHelp } from "./Components/FAQSHelp/FAQSHelp";
import useScreenWidth from "./Hooks/useScreenWidth";
import UniversalLifeInsurance from "./Pages/Product/UniversalLifeInsurance";
import IndexedUniversalLifeInsurance from "./Pages/Product/IndexedUniversalLifeInsurance";
import TermLifeInsurance from "./Pages/Product/TermLifeInsurance";
import CriticalIllnessInsurance from "./Pages/Product/CriticalIllnessInsurance";
import ComparePlans from "./Pages/Compare/ComarePlans";
import ScrollToTop from "./Components/ScrollToTop";
import ScrollToHashElement from "./Hooks/useScrollToHash";
import LanguageProvider from "./Hooks/langugaeContext";
import TermsOfUse from "./Pages/TermsPrivacySecure/TermsOfUse";
import Secure from "./Pages/TermsPrivacySecure/Secure";
import Privacy from "./Pages/TermsPrivacySecure/Privacy";
import Footnotes from "./Pages/TermsPrivacySecure/Footnotes";
import CreditedInterestRate from "./Pages/CreditedInterestRate";

const App = () => {
  const screenSize = useScreenWidth();
  const appClass = screenSize > 991 ? "desktop" : "mobile";

  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <ScrollToHashElement />

        <div className={`${appClass}`}>
          {/* { <NavBar /> } */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="home" element={<HomePage />} />
            <Route path="about" element={<About />} />
            <Route path="users/*" element={<NavBar />} />
            {/* <Route path="af-care" element={<AfCare />} /> */}
            {/* <Route path="hospitals" element={<Hospitals />} /> */}
            <Route path="faqs" element={<FAQSHelp />} />
            <Route
              path="universal-life-insurance"
              element={<UniversalLifeInsurance />}
            />
            <Route
              path="indexed-universal-life-insurance"
              element={<IndexedUniversalLifeInsurance />}
            />
            <Route path="term-life-insurance" element={<TermLifeInsurance />} />
            <Route
              path="critical-illness-insurance"
              element={<CriticalIllnessInsurance />}
            />
            <Route path="compare-plans" element={<ComparePlans />} />
            <Route path="terms" element={<TermsOfUse />} />
            <Route path="secure" element={<Secure />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="footnotes" element={<Footnotes />} />
            <Route
              path="/credited-interest-rate"
              element={<CreditedInterestRate />}
            />
          </Routes>
          <Footer />
          <TermsCondition />
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
